import styled from "styled-components";

const NewsLetterStyleWrapper = styled.section`
  padding-bottom: 80px;

  .section_title {
    margin-bottom: 45px;
  }

  .row {
    row-gap: 20px;
  }
`;

export default NewsLetterStyleWrapper;
